// Presentational helpers shared by ShipmentListScreen and ShipmentDetailScreen.
// The fixture data that used to live here (mock PreAlert/Package rows) is gone
// now that both screens are wired to the real API — see
// docs/shipment-integration-frontend.md.

import type { PackageStatus, ShipmentStatus } from '@/types/shipment';

export const STATUS_BADGE_CLASS: Record<PackageStatus, string> = {
  AwaitingRegistration: 'border-border/60 bg-secondary/40 text-muted-foreground',
  InvoiceRendered: 'border-accent/40 bg-accent/10 text-foreground',
  DeclaredInfo: 'border-accent/40 bg-accent/15 text-foreground',
  DeclaredInvoice: 'border-accent/40 bg-accent/20 text-foreground',
  DeclarationSubmitted: 'border-primary/40 bg-primary/15 text-foreground',
  DeclarationFeesReceived: 'border-primary/40 bg-primary/20 text-foreground',
  DeclarationReceiptReceived: 'border-warning/40 bg-warning/15 text-warning',
  DeclarationClassificationReceived: 'border-warning/40 bg-warning/20 text-warning',
  DeclarationFeesPaid: 'border-success/40 bg-success/15 text-success',
  Duplicate: 'border-destructive/40 bg-destructive/15 text-destructive',
};

export const SHIPMENT_STATUS_BADGE_CLASS: Record<ShipmentStatus, string> = {
  PreAlert: 'border-border/60 bg-secondary/40 text-muted-foreground',
  ApiReceived: 'border-accent/40 bg-accent/15 text-foreground',
  CustomCleared: 'border-primary/40 bg-primary/15 text-foreground',
  Noa: 'border-warning/40 bg-warning/15 text-warning',
  DriverCollected: 'border-success/40 bg-success/15 text-success',
  PalletScanned: 'border-success/40 bg-success/20 text-success',
};

const DEFAULT_SHIPMENT_STATUS_BADGE_CLASS = 'border-border/60 bg-secondary/40 text-muted-foreground';

/** `status` is the raw backend value (see `ShipmentRow.status`) — falls back to a neutral badge for anything outside `SHIPMENT_STATUSES`. */
export function shipmentStatusBadgeClass(status: string): string {
  return SHIPMENT_STATUS_BADGE_CLASS[status as ShipmentStatus] ?? DEFAULT_SHIPMENT_STATUS_BADGE_CLASS;
}

export function formatMoney(amount: number | null, currency: string): string {
  if (amount === null) return '—';
  return `${amount.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency}`;
}
